// removed by extract-text-webpack-plugin
module.exports = {"hidden":"dots__hidden--6QI6w","dots":"dots__dots--3DTlP","dot":"dots__dot--qkNAR","dotActive":"dots__dotActive--1NgkZ dots__dot--qkNAR","noTransition":"dots__noTransition--2CdtV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Carousel/dots.css
// module id = WwGx
// module chunks = 0